import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "horizontal-card-content" }
const _hoisted_2 = { class: "flag-container" }
const _hoisted_3 = {
  key: 1,
  class: "flag-border"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "right-group" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "favorite-icon-wrapper" }
const _hoisted_9 = { class: "time-block" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "time-block" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "time-block" }
const _hoisted_16 = { class: "time" }
const _hoisted_17 = { class: "label" }

import { getGameLogoUrl } from '@/utils/resultParser';
import type { UpcomingDraw } from '@/types/lottery';

import { useIntegrationMode } from '@/composables/useIntegrationMode'
import CountryAvatar from '@/components/base/CountryAvatar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HorizontalLotteryCard',
  props: {
    lottery: {},
    isFavorited: { type: Boolean },
    countdown: {},
    favoriteIcon: {},
    favoriteFilledIcon: {}
  },
  emits: ['favorite', 'navigate'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const { isLite } = useIntegrationMode()

const navigateToDetail = () => {
  emit('navigate');
};

const handleCardClick = (event: MouseEvent) => {
  if (event.target === event.currentTarget) {
    navigateToDetail();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "draw-card horizontal",
    tabindex: "0",
    role: "button",
    onClick: handleCardClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "left-group",
        onClick: navigateToDetail
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(isLite))
            ? (_openBlock(), _createBlock(CountryAvatar, {
                key: 0,
                country: _ctx.lottery.country,
                "fallback-label": _ctx.lottery.game_name,
                size: "md"
              }, null, 8, ["country", "fallback-label"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo, _ctx.lottery.game_slug),
                  alt: _ctx.lottery.country + ' flag',
                  class: "flag"
                }, null, 8, _hoisted_4)
              ]))
        ]),
        _createElementVNode("h3", {
          class: "lottery-name",
          title: _ctx.lottery.game_name
        }, _toDisplayString(_ctx.lottery.game_name), 9, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_unref(isLite))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["favorite-btn-inline", { active: _ctx.isFavorited }]),
              "aria-label": _ctx.$t('common.toggleFavorite'),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('favorite')), ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock("svg", {
                  viewBox: "0 0 24 24",
                  class: _normalizeClass(["favorite-icon-svg", { filled: _ctx.isFavorited }]),
                  xmlns: "http://www.w3.org/2000/svg"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("path", { d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" }, null, -1)
                ]), 2))
              ])
            ], 10, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "countdown-section",
          onClick: navigateToDetail
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(String(_ctx.countdown.hours).padStart(2, '0')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('time.hours')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(String(_ctx.countdown.minutes).padStart(2, '0')), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('time.mins')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(String(_ctx.countdown.seconds).padStart(2, '0')), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('time.secs')), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})